import { DevTool } from '@hookform/devtools'
import { yupResolver } from '@hookform/resolvers/yup'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import { acGetAllAccessKeys, acGetAllApplicationServices, acPostAccessKey } from '../../store/actions'
import { PrimaryButton, Alert } from '../default'

import { FormSelect } from './formInputs'
import { FormValidationCreateAccessKey } from './formValidations'

/**
 * @description Renders a form for creating an access key. It uses the react-hook-form library for form validation and submission.
 *
 * @author Isadora Botassari, Maria Eduarda Franke
 * @param {function} props.onClose - The function to close the form.
 * @param {function} props.setShowSnackbar - The function to set the visibility of a snackbar.
 * @returns {JSX.Element} The rendered CreateAccessKeyForm component.
 */
export const CreateAccessKeyForm = ({ onClose, setShowSnackbar }) => {

    const defaultValues = {
        applicationServiceId: ''
    }

    const dispatch = useDispatch()

    const allApplicationServices = useSelector(state => state.applicationServices.allApplicationServices)

    const isCreatingKey = useSelector(state => state.accessKeys.isCreatingKey)
    const hasErrorCreatedKey = useSelector(state => state.accessKeys.hasErrorCreatedKey)

    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(FormValidationCreateAccessKey)
    })

    useEffect(() => {
        dispatch(acGetAllApplicationServices())
            .catch(error => console.error(error))
        // eslint-disable-next-line
    }, [])

    const onSubmit = handleSubmit((data) => {
        dispatch(acPostAccessKey(data.applicationServiceId))
            .then(() => {
                onClose()
                setShowSnackbar(true)
                dispatch(acGetAllAccessKeys())
                    .catch(error => console.error(error))
            })
            .catch(error => console.error(error))
    })

    return (
        <Box
            component='form' onSubmit={onSubmit} noValidate
            display='flex' flexDirection='column' gap={2}
        >

            <DevTool control={control} />

            <FormSelect
                name='applicationServiceId'
                label='Aplicação'
                items={allApplicationServices || []}
                itemId='company_application_service_id'
                control={control}
                errors={errors.applicationServiceId}
                fullWidth
                required
            />

            {hasErrorCreatedKey && (
                <Alert severity='error' message='Erro ao criar chave de acesso!' />
            )}

            <PrimaryButton
                label='Criar Chave de Acesso'
                loading={isCreatingKey}
                type='submit'
                fullWidth
            />

        </Box>
    )

}

CreateAccessKeyForm.propTypes = {
    onClose: PropTypes.func.isRequired,
    setShowSnackbar: PropTypes.func.isRequired
}
